import React, {Component} from 'react';
import Header from './header';
import AdArea from './adArea';
import '../style.css';
import __ from 'underscore';
import classNames from 'classnames';
import reactMixin from 'react-mixin';
import Entity from './mixins/olympic';
import Ua from './modules/ua';
import {MINDS_AREA_TO_GGM_GROUP_ID} from "./configure/configure";

class Olympic extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dates: [], channels: [], programs: [], channelMaps: {}
        };
    }

    componentDidMount() {
        this.addCrossBarScrollEvent();
        const {areaId} = this.props.match.params;
        this.updateScheduleAction(areaId);
    }

    componentWillReceiveProps(nextProps) {
        this.setScrollStartPos();
        this.addCrossBarScrollEvent();
        const {areaId} = nextProps.match.params;
        this.updateScheduleAction(areaId);
    }

    render() {
        const {areaId} = this.props.match.params;
        const timeList = __.range(6, 25).map(val => {
            return <li key={val}><p>{val}</p></li>;
        });
        const dateList = this.state.dates.map(dateObj => {
            return <li className={'column_' + dateObj.chNum} key={dateObj.date} id={"date_" + dateObj.formatDate}>
                <p>{dateObj.formatDate}</p></li>;
        });
        const channelList = this.state.channels.map((val, index) => {
            const channelMap = this.state.channelMaps;
            let name = "";
            if (channelMap[val]) {
                name = ~channelMap[val].indexOf("NHK") ? "NHK" : channelMap[val];
            }
            return <li key={index}><p>{name}</p></li>;
        });
        const programList = (list, parentIndex) => {
            return list.map((program, index) => {
                const pos = this.calcProgramPos(program.startTime, program.endTime);
                const _url = program.url ? program.url + "&from=gorin&overwrite_area=" + MINDS_AREA_TO_GGM_GROUP_ID[areaId] : undefined;
                return <li style={{top: pos.top + 'px', height: pos.height + 'px'}} key={parentIndex + '_' + index}>
                    <a href=""
                       onClick={e => this.goSiPage(e, _url)}>
                        <p className={classNames("program_time", "start-" + program.startTime.substr(8, 2))}>{program.startTime.slice(-2)}</p>
                        <p className="program_title">{program.title}</p>
                    </a>
                </li>
            });
        };
        const rootSection = Ua.isPcUser(navigator.userAgent) ? "pc-display" : "mobile-display";
        return (
            <section className={rootSection}>
                <Header areaId={this.props.match.params.areaId}/>
                <div id="top_ber">
                    <ul id="date">
                        {dateList}
                    </ul>
                    <ul id="broadcaster">
                        {channelList}
                    </ul>
                </div>
                <div id="left_ber">
                    <ul id="time">
                        {timeList}
                    </ul>
                </div>
                <div id="fixed_box">
                </div>
                <div id="contents">
                    {this.state.programs.map((val, index) => {
                        return <div className={classNames("one_day", "color_" + (val.dateIndex % 7 + 1))} key={index}>
                            <ul>
                                {programList(val.data, index)}
                            </ul>
                        </div>
                    })}
                </div>
                <AdArea/>
            </section>
        );
    }
}

reactMixin.onClass(Olympic, Entity);

export default Olympic;



// WEBPACK FOOTER //
// ./src/components/olympic.js